import React from 'react';
import Footer from 'components/Footer';

const PrivacyPolicy = () => {
  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-b from-white to-blue-50">
      {/* Navigation Bar */}
      <nav className="bg-white/90 backdrop-blur-sm shadow-sm sticky top-0 z-50 transition-all duration-300">
        {/* Using the same NavBar structure as Home.js */}
        <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
          <a href="/" className="flex items-center space-x-3 transform hover:scale-105 transition-transform duration-300">
            <img src="/logo3.png" className="h-10 md:h-14" alt="Logo" />
            <span className="self-center text-xl md:text-2xl font-semibold text-gray-800">ChemSafe</span>
          </a>
        </div>
      </nav>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-8 mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Privacy Policy</h1>
          
          <div className="prose max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Introduction</h2>
              <p className="text-gray-600">
                This Privacy Policy describes how ChemSafe ("we", "our", or "us") collects, uses, and protects 
                your information when you use our website and services.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Information We Collect</h2>
              <ul className="list-disc pl-6 text-gray-600 space-y-2">
                <li>Survey responses and research participation data</li>
                <li>Contact information (email address for newsletter subscription)</li>
                <li>Usage data and analytics</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">How We Use Your Information</h2>
              <ul className="list-disc pl-6 text-gray-600 space-y-2">
                <li>To conduct research on chemical safety management</li>
                <li>To improve our tools and services</li>
                <li>To send you updates about our research (if subscribed)</li>
                <li>To analyze usage patterns and improve user experience</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Data Protection</h2>
              <p className="text-gray-600">
                We implement appropriate security measures to protect your information. All data is stored 
                securely and accessed only by authorized research team members.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">Contact Us</h2>
              <p className="text-gray-600">
                For any privacy-related questions, please contact us at:{' '}
                <a href="mailto:chemsafe.iitm@gmail.com" className="text-blue-600 hover:text-blue-800">
                  chemsafe.iitm@gmail.com
                </a>
              </p>
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
